import { Component, input, output } from '@angular/core';
import { IconCheckbox } from '../../icons/i-checkbox';
import { IconThumb } from '../../icons/i-thumb';
import { RidButton } from '../rid-button/rid-button';

@Component({
  selector: 'rid-feedback-toast',
  imports: [RidButton, IconCheckbox, IconThumb],
  templateUrl: './rid-feedback-toast.html',
  host: {
    class: 'absolute bottom-0 w-4xl cursor-pointer',
    'animate.enter': 'anim-slide-from-bottom',
    'animate.leave': 'anim-slide-to-bottom',
  },
})
export class RidFeedbackToast {
  title = input.required<string>();
  description = input.required<string>();
  variant = input.required<'SUCCESS' | 'INFO'>();

  continued = output<void>();
}
